import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38bb4668"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-close fw-bold",
  "aria-hidden": "true"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_button = _resolveComponent("v-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    (!_ctx.disableClose)
      ? (_openBlock(), _createBlock(_component_v_button, {
          key: 0,
          variant: "link",
          class: "fw-medium btn-close",
          "aria-label": _ctx.$t('Cerrar'),
          "data-bs-dismiss": "modal",
          onClick: _ctx.closeModal
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["aria-label", "onClick"]))
      : _createCommentVNode("", true)
  ]))
}